import { useState, useCallback, useRef } from 'react';
export default function useResizeObserver() {
    var _a = useState(0), footerHeight = _a[0], setFooterHeight = _a[1];
    var observerRef = useRef(null);
    // We use a Ref to keep track of the value for comparison
    // without triggering re-renders or stale closures.
    var heightRef = useRef(0);
    var elementRef = useCallback(function (node) {
        if (observerRef.current) {
            observerRef.current.disconnect();
        }
        if (node !== null) {
            observerRef.current = new ResizeObserver(function (entries) {
                for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
                    var entry = entries_1[_i];
                    var newHeight = entry.contentRect.height;
                    // Compare against the Ref, not the State
                    if (heightRef.current !== newHeight) {
                        heightRef.current = newHeight; // Update ref immediately
                        setFooterHeight(newHeight); // Update state for React
                        // Manual DOM adjustment
                        var container = document.querySelector('.toolBottomPanelContainer');
                        var manipulativeTool = document.querySelector('#manipulativeToolSmartBoard');
                        // if (manipulativeTool) {
                        //   manipulativeTool.style.bottom = `${newHeight + 25}px`;
                        // }
                        if (container) {
                            container.style.bottom = "".concat(newHeight + 25, "px");
                        }
                    }
                }
            });
            observerRef.current.observe(node);
        }
    }, []); // Empty array is fine now because we use heightRef.current
    return { elementRef: elementRef };
}
